import React, { useState, ChangeEvent } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import StyledButton from '../../../components/Button/Button';
import EmailInput from '../../../components/Inputs/EmailInput';
import {
  Box,
  Container,
  Typography,
  CircularProgress,
  FormControl,
} from '@mui/material';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import './Forgotpassword.css';
import TopNav from '../../../components/TopNav/TopNav';
import { forgotPassword } from '../../../services/NetworkServices';
import { storeEmail, getRole } from '../../../utils/auth-token-utils/cookie';
import ApiStatus from '../../../config/apiStatusConstants';
import { commonResponse } from '../../../services/types/APIResponseType';

const Forgotpassword: React.FC = () => {
  const [apiStatus, setApiStatus] = useState<ApiStatus>(ApiStatus.INITIAL);
  const [email, setEmail] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');
  const role = getRole();

  const navigate = useNavigate();

  const onChangeEmail = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleSendingCode = async () => {
    storeEmail(email);
    setApiStatus(ApiStatus.LOADING);
    try {
      const response = await forgotPassword({
        email: email || '',
        role: role || '',
      });
      console.log('response is', response);
      const data: commonResponse = await response.data;
      if (data) {
        setApiStatus(ApiStatus.SUCCESS);
        navigate('/verifycode');
      }
    } catch (error: any) {
      setApiStatus(ApiStatus.FAILURE);
      console.log('error is', error);
      setErrorMsg(
        error.response.data.message ||
          'Something went wrong. Please try again.',
      );
    }
  };

  const renderButton = () => {
    if (apiStatus === ApiStatus.LOADING) {
      return (
        <div className="buttonContainer">
          <StyledButton>
            <CircularProgress size={20} />
          </StyledButton>
        </div>
      );
    } else {
      return (
        <div className="buttonContainer">
          <StyledButton onClick={handleSendingCode} disabled={!email}>
            Send Code
          </StyledButton>
        </div>
      );
    }
  };

  const renderErrorMsg = () => {
    if (apiStatus === ApiStatus.FAILURE) {
      return <p className="error-msg">{errorMsg}</p>;
    }
    return null;
  };

  return (
    <StyledBgContainer>
      <TopNav showArrow={true} />
      <Container maxWidth="sm">
        <Box component="form" noValidate autoComplete="off">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              px: { sm: 6 },
            }}
          >
            <Typography
              variant="h6"
              sx={{ color: 'white', fontFamily: 'Opensans', fontWeight: '700' }}
            >
              Reset Password
            </Typography>
            <Typography variant="body2" sx={{ color: 'grey', mt: 1, mb: 3 }}>
              Enter your registered email to reset password
            </Typography>
            <FormControl
              fullWidth
              variant="outlined"
              sx={{ mb: 2, alignItems: 'center' }}
            >
              <EmailInput
                type="email"
                value={email}
                onChange={onChangeEmail}
                label="Email Address"
                placeholder="Enter your email"
              />
            </FormControl>
            <Box
              className="error-msg"
              sx={{
                marginTop: '-20px',
                width: { xs: '80vw', sm: '60vw', md: '60vw', lg: '40vw' },
              }}
            >
              {renderErrorMsg()}
            </Box>
          </Box>
        </Box>

        <Box sx={{ mt: 6 }}> {renderButton()}</Box>

        <Box sx={{ mt: 3 }}>
          <Typography sx={{ color: 'grey', mt: 6, mb: 3 }}>
            Back to{' '}
            <Link className="linkstyle" to="/signin">
              Sign In{' '}
            </Link>
          </Typography>
        </Box>
      </Container>
    </StyledBgContainer>
  );
};

export default Forgotpassword;
